import React, { useEffect, useMemo } from "react"
import { Container } from "reactstrap"
import { getConfig } from "../../api"

export default function SettingsPage() {
  const [config, setConfig] = React.useState({})
  useEffect(() => {
    getConfig().then(res => {
      console.log(res)
      setConfig(res)
    })
  }, [])
  document.title = "Settings"
  const columns = useMemo(
    () => [
      {
        header: "Number",
        accessorKey: "orderNumber",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Created At",
        accessorKey: "createdDate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const date = new Date(cell.getValue())
          return date.toLocaleDateString() + " " + date.toLocaleTimeString()
        },
      },

      {
        header: "Type",
        accessorKey: "orderType",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "User ID",
        accessorKey: "userId",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => openOrderInNewTab(row)}
          >
            View
          </button>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h2>Settings</h2>
          {config && Object.keys(config).length > 0 ? (
            Object.keys(config).map(key => {
              return (
                <div key={key} className="mb-3" style={{display: "flex", gap: "1rem", alignItems: "center"}}>
                  <strong style={{ textTransform: "capitalize" }}>
                    {key}:{" "}
                  </strong>

                  {Object.keys(config[key]).length > 0 ? (
                    Object.keys(config[key][0]).map(subKey => (
                      <div
                        key={subKey}
                        style={{ textTransform: "capitalize", width: '300px', display: 'flex', alignItems: 'center', marginTop: '10px' }}
                      >
                        <br />
                        <div style={{width:'50px'}}>{subKey}</div>:<input className={"form-control form-control-sm"} value= {config[key][0][subKey]} style={{marginLeft: "10px"}}/>
                      </div>
                    ))
                  ) : (
                    <input className={"form-control form-control-sm "} style={{width:'200px'}} value={config[key]} />
                  )}
                </div>
              )
            })
          ) : (
            <p>No settings available</p>
          )}
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Save Changes
          </button>
        </Container>
      </div>
    </React.Fragment>
  )
}
